import React from 'react';
import { Menu, X, Store, Trophy, BookOpen, Bot, Settings as SettingsIcon } from 'lucide-react';

interface MobileMenuProps {
  isOpen: boolean;
  onToggle: () => void;
  onShowShop: () => void;
  onShowChallenges: () => void;
  onShowRecipeBook: () => void;
  onToggleAI: () => void;
  onShowSettings: () => void;
  aiBarista: any;
}

const MobileMenu: React.FC<MobileMenuProps> = ({
  isOpen,
  onToggle,
  onShowShop,
  onShowChallenges,
  onShowRecipeBook,
  onToggleAI,
  onShowSettings,
  aiBarista,
}) => {
  const handleAction = (action: () => void) => {
    action();
    onToggle();
  };

  return (
    <div className="mobile-menu-container relative">
      <button
        onClick={onToggle}
        className="p-2 rounded-lg bg-text-secondary hover:bg-opacity-80 transition-colors h-9 w-9 flex items-center justify-center"
      >
        {isOpen ? <X size={18} /> : <Menu size={18} />}
      </button>
      
      {isOpen && (
        <div className="absolute top-full right-0 mt-1 bg-text-primary border border-white/20 rounded-lg shadow-lg py-2 min-w-[180px] z-50">
          <button
            onClick={() => handleAction(onShowShop)}
            data-tutorial-id="shop-button"
            className="w-full text-left px-3 py-2 hover:bg-white/10 flex items-center gap-2 min-h-[36px] text-sm"
          >
            <Store size={16} />
            <span>Shop</span>
          </button>
          <button
            onClick={() => handleAction(onShowChallenges)}
            className="w-full text-left px-3 py-2 hover:bg-white/10 flex items-center gap-2 min-h-[36px] text-sm"
          >
            <Trophy size={16} />
            <span>Challenges</span>
          </button>
          <button
            data-tutorial-id="recipe-book-button"
            onClick={() => handleAction(onShowRecipeBook)}
            className="w-full text-left px-3 py-2 hover:bg-white/10 flex items-center gap-2 min-h-[36px] text-sm"
          >
            <BookOpen size={16} />
            <span>Recipes</span>
          </button>
          {aiBarista.level > 0 && (
            <button
              onClick={() => handleAction(onToggleAI)}
              className={`w-full text-left px-3 py-2 hover:bg-white/10 flex items-center gap-2 min-h-[36px] text-sm ${
                aiBarista.active ? 'bg-success/20' : ''
              }`}
            >
              <Bot size={16} />
              <span>AI: {aiBarista.active ? 'ON' : 'OFF'}</span>
            </button>
          )}
          <button
            onClick={() => handleAction(onShowSettings)}
            className="w-full text-left px-3 py-2 hover:bg-white/10 flex items-center gap-2 min-h-[36px] text-sm"
          >
            <SettingsIcon size={16} />
            <span>Settings</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default MobileMenu;
